(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunavera-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeLunaveraHero(root) {
      if (!root) return;

      var slider = root.querySelector('[data-lvh-slider]');

      if (!slider) return;

      if (typeof slider._lvhDestroy === 'function') {
        slider._lvhDestroy();
      }

      var slides = Array.prototype.slice.call(
        slider.querySelectorAll('[data-lvh-slide]')
      );

      var thumbnails = Array.prototype.slice.call(
        slider.querySelectorAll('[data-lvh-thumb]')
      );

      var previousButton = slider.querySelector('[data-lvh-prev]');
      var nextButton = slider.querySelector('[data-lvh-next]');
      var pauseButton = slider.querySelector('[data-lvh-pause]');
      var progressBar = slider.querySelector('[data-lvh-progress]');

      var autoplayEnabled = slider.dataset.autoplay === 'true';
      var duration = parseInt(slider.dataset.duration, 10) || 6000;

      var reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      var currentIndex = 0;
      var timer = null;
      var paused = false;
      var isVisible = true;
      var observer = null;

      if (!slides.length) return;

      function clearAutoplay() {
        if (timer !== null) {
          window.clearTimeout(timer);
          timer = null;
        }
      }

      function resetProgress() {
        if (!progressBar) return;

        progressBar.classList.remove('lvh-running');
        progressBar.style.animation = 'none';

        void progressBar.offsetWidth;

        progressBar.style.animation = '';
        progressBar.style.setProperty(
          '--lvh-duration',
          duration + 'ms'
        );
      }

      function startProgress() {
        if (!progressBar) return;

        resetProgress();

        if (
          autoplayEnabled &&
          !paused &&
          isVisible &&
          !reduceMotion &&
          slides.length > 1
        ) {
          progressBar.classList.add('lvh-running');
        }
      }

      function restartAutoplay() {
        clearAutoplay();
        resetProgress();

        if (
          !autoplayEnabled ||
          paused ||
          !isVisible ||
          reduceMotion ||
          slides.length < 2 ||
          document.hidden
        ) {
          return;
        }

        startProgress();

        timer = window.setTimeout(function () {
          goToSlide(currentIndex + 1);
        }, duration);
      }

      function goToSlide(index) {
        if (slides.length < 2) return;

        var newIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, i) {
          var active = i === newIndex;

          slide.classList.toggle('lvh-active', active);
          slide.setAttribute(
            'aria-hidden',
            active ? 'false' : 'true'
          );

          if (active) {
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('inert', '');
          }
        });

        thumbnails.forEach(function (thumb, i) {
          var active = i === newIndex;

          thumb.classList.toggle('lvh-active', active);
          thumb.setAttribute(
            'aria-current',
            active ? 'true' : 'false'
          );

          if (active) {
            var container = thumb.parentElement;

            if (container) {
              var left = thumb.offsetLeft;
              var right = left + thumb.offsetWidth;
              var visibleLeft = container.scrollLeft;
              var visibleRight = visibleLeft + container.clientWidth;

              if (left < visibleLeft) {
                container.scrollTo({
                  left: left,
                  behavior: reduceMotion ? 'auto' : 'smooth'
                });
              } else if (right > visibleRight) {
                container.scrollTo({
                  left: right - container.clientWidth,
                  behavior: reduceMotion ? 'auto' : 'smooth'
                });
              }
            }
          }
        });

        currentIndex = newIndex;
        restartAutoplay();
      }

      function onPrevious() {
        goToSlide(currentIndex - 1);
      }

      function onNext() {
        goToSlide(currentIndex + 1);
      }

      function onPause() {
        paused = !paused;

        if (pauseButton) {
          pauseButton.classList.toggle('lvh-paused', paused);
          pauseButton.setAttribute(
            'aria-label',
            paused ? 'Play slideshow' : 'Pause slideshow'
          );
          pauseButton.setAttribute(
            'aria-pressed',
            paused ? 'true' : 'false'
          );
        }

        restartAutoplay();
      }

      function onVisibilityChange() {
        if (document.hidden) {
          clearAutoplay();
          resetProgress();
        } else {
          restartAutoplay();
        }
      }

      function onKeydown(event) {
        if (!slider.contains(document.activeElement)) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          onPrevious();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          onNext();
        }
      }

      function onMouseEnter() {
        clearAutoplay();
        resetProgress();
      }

      function onMouseLeave() {
        restartAutoplay();
      }

      function onFocusIn() {
        clearAutoplay();
        resetProgress();
      }

      function onFocusOut(event) {
        if (!slider.contains(event.relatedTarget)) {
          restartAutoplay();
        }
      }

      function onBlockSelect(event) {
        var selectedBlock = event.target.closest('[data-lvh-slide]');

        if (!selectedBlock || !slider.contains(selectedBlock)) {
          return;
        }

        var selectedIndex = parseInt(
          selectedBlock.dataset.slideIndex,
          10
        );

        paused = true;

        if (pauseButton) {
          pauseButton.classList.add('lvh-paused');
          pauseButton.setAttribute(
            'aria-label',
            'Play slideshow'
          );
          pauseButton.setAttribute(
            'aria-pressed',
            'true'
          );
        }

        goToSlide(selectedIndex);
      }

      if (previousButton) {
        previousButton.addEventListener('click', onPrevious);
      }

      if (nextButton) {
        nextButton.addEventListener('click', onNext);
      }

      if (pauseButton) {
        pauseButton.addEventListener('click', onPause);
      }

      var thumbnailHandlers = [];

      thumbnails.forEach(function (thumb, index) {
        var handler = function () {
          goToSlide(index);
        };

        thumb.addEventListener('click', handler);

        thumbnailHandlers.push({
          element: thumb,
          handler: handler
        });
      });

      slider.addEventListener('mouseenter', onMouseEnter);
      slider.addEventListener('mouseleave', onMouseLeave);
      slider.addEventListener('focusin', onFocusIn);
      slider.addEventListener('focusout', onFocusOut);

      document.addEventListener(
        'visibilitychange',
        onVisibilityChange
      );

      document.addEventListener('keydown', onKeydown);

      document.addEventListener(
        'shopify:block:select',
        onBlockSelect
      );

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              isVisible = entry.isIntersecting;

              if (isVisible) {
                restartAutoplay();
              } else {
                clearAutoplay();
                resetProgress();
              }
            });
          },
          {
            threshold: 0.15
          }
        );

        observer.observe(slider);
      }

      restartAutoplay();

      slider._lvhDestroy = function () {
        clearAutoplay();

        if (observer) {
          observer.disconnect();
        }

        if (previousButton) {
          previousButton.removeEventListener('click', onPrevious);
        }

        if (nextButton) {
          nextButton.removeEventListener('click', onNext);
        }

        if (pauseButton) {
          pauseButton.removeEventListener('click', onPause);
        }

        thumbnailHandlers.forEach(function (item) {
          item.element.removeEventListener(
            'click',
            item.handler
          );
        });

        slider.removeEventListener('mouseenter', onMouseEnter);
        slider.removeEventListener('mouseleave', onMouseLeave);
        slider.removeEventListener('focusin', onFocusIn);
        slider.removeEventListener('focusout', onFocusOut);

        document.removeEventListener(
          'visibilitychange',
          onVisibilityChange
        );

        document.removeEventListener('keydown', onKeydown);

        document.removeEventListener(
          'shopify:block:select',
          onBlockSelect
        );
      };
    }

    function initializeAllLunaveraHeroes(scope) {
      var container = scope || document;

      var sliders = container.querySelectorAll('[data-lvh-slider]');

      sliders.forEach(function (slider) {
        var sectionRoot = slider.closest('.shopify-section');

        if (sectionRoot) {
          initializeLunaveraHero(sectionRoot);
        }
      });
    }

    function onDocumentReady() {
      initializeAllLunaveraHeroes(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        onDocumentReady,
        { once: true }
      );
    } else {
      onDocumentReady();
    }

    if (!window.lunaveraHeroEventsRegistered) {
      window.lunaveraHeroEventsRegistered = true;

      document.addEventListener(
        'shopify:section:load',
        function (event) {
          initializeAllLunaveraHeroes(event.target);
        }
      );

      document.addEventListener(
        'shopify:section:unload',
        function (event) {
          var sliders = event.target.querySelectorAll(
            '[data-lvh-slider]'
          );

          sliders.forEach(function (slider) {
            if (typeof slider._lvhDestroy === 'function') {
              slider._lvhDestroy();
            }
          });
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
